import { render, staticRenderFns } from "./actions-pos-requests.vue?vue&type=template&id=286642c2"
import script from "./actions-pos-requests.vue?vue&type=script&lang=js"
export * from "./actions-pos-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports